class PisOfflineAudioListController {
  constructor($uibModal) {
    'ngInject';
    this.$uibModal = $uibModal;
    const ctrl = this;
  }

  $onInit = () => {
    this.sortType = 'number';
    this.sortReverse = false;
  }

  $onChanges(changes) {
    if (changes.data) {
      this.data = angular.copy(this.data);
    }
    if (changes.modalOptions) {
      this.modalOptions = angular.copy(this.modalOptions);
    }
  }

  setSortType = column => {
    this.sortType = column;
  };

  setSortReverse = () => {
    this.sortReverse = !this.sortReverse;
  };

  toggleEditMode($event, item) {
    $event.preventDefault();
    $event.stopPropagation();
    this.editMode = true;
    this.onToggle({
      $event: {
        editMode: true,
        item: item,
      },
    });
  }
}

angular
  .module('offline.module')
  .controller('PisOfflineAudioListController', PisOfflineAudioListController);
